module.exports = __webpack_public_path__ + "static/media/RobotoSlab-Light.4d8f30f8.ttf";